import {
  buildImpactedClientsReview,
  buildImpactedCohortMatch,
  sortCohortsForImpactReview,
} from '../../domain/services/cohortImpactReviewService';

/** @typedef {
 *   import('./createCareModelCohortImpactReview.types').GetImpactedClientsParams
 * } GetImpactedClientsParams */
/** @typedef {
 *   import('../../domain/entities/CareModelCohortImpactReview.types').ImpactedCareModelCohortAssignment
 * } ImpactedCareModelCohortAssignment */
/** @typedef {
 *   import('./createCareModelCohortImpactReview.types').CareModelCohortImpactReviewUseCase
 * } CareModelCohortImpactReviewUseCase */

/**
 * @param {Function} hydrateFilters
 * @param {Function} getFilteredElements
 * @returns {CareModelCohortImpactReviewUseCase}
 */
// eslint-disable-next-line import/prefer-default-export
export function createCareModelCohortImpactReview(
  hydrateFilters,
  getFilteredElements,
) {
  /**
   * @param {GetImpactedClientsParams} params
   * @returns {ImpactedCareModelCohortAssignment[]}
   */
  function getImpactedClients({ clients = [], cohorts = [], columns = [] }) {
    const sortedCohorts = sortCohortsForImpactReview(cohorts);

    return buildImpactedClientsReview({
      clients,
      getMatchesForClient(client) {
        return sortedCohorts.reduce((acc, cohort) => {
          const hydratedFilters = hydrateFilters(cohort.filters || {}, columns);
          const matchedClients = getFilteredElements([client], hydratedFilters);

          if (!matchedClients.length) {
            return acc;
          }

          acc.push(buildImpactedCohortMatch(cohort, hydratedFilters));
          return acc;
        }, []);
      },
    });
  }

  return {
    getImpactedClients,
  };
}
